module.exports = __webpack_public_path__ + "static/media/vertical-link.7d27fae4.svg";